import { useState, useEffect } from "react";
import "./OfferModal.css";
import { FaBriefcase, FaFutbol, FaUserTie, FaHeartbeat, FaSearch, FaVideo, FaTimes } from "react-icons/fa";
import { post } from "../http/api";
import { useTranslation } from "react-i18next";



export default function OfferModal({ open, onClose }) {

    const [step, setStep] = useState(1);

    const [loading, setLoading] = useState(false);

    const [feedback, setFeedback] = useState("");

    const [feedbackType, setFeedbackType] = useState("");

    const [offerData, setOfferData] = useState({
        role: "",
        title: "",
        description: "",
        country: "",
        city: "",
        filters: {}
    });

    const { t } = useTranslation();


    useEffect(() => {
        if (open) {
            document.body.style.overflow =
                "hidden";
        }
        else {
            document.body.style.overflow =
                "auto";
        }

        return () => {
            document.body.style.overflow =
                "auto";
        };
    }, [open]);

    if (!open) return null;

    const OFFER_ROLES = [

        {
            key: "athlete",
            label: t("offerModal.athlete"),
            icon: <FaFutbol />
        },

        {
            key: "coach",
            label: t("offerModal.coach"),
            icon: <FaUserTie />
        },

        {
            key: "physical_trainer",
            label: t("offerModal.physicalTrainer"),
            icon: <FaHeartbeat />
        },

        {
            key: "scout",
            label: t("offerModal.scout"),
            icon: <FaSearch />
        },

        {
            key: "video_analyst",
            label: t("offerModal.videoAnalyst"),
            icon: <FaVideo />
        },

        {
            key: "physio",
            label: t("offerModal.physio"),
            icon: <FaHeartbeat />
        },

        {
            key: "nutritionist",
            label: t("offerModal.nutritionist"),
            icon: <FaHeartbeat />
        },

        {
            key: "mental_coach",
            label: t("offerModal.mentalCoach"),
            icon: <FaUserTie />
        },

        {
            key: "agent",
            label: t("offerModal.agent"),
            icon: <FaBriefcase />
        }

    ];

    const LEVELS = [
        t("offerModal.amateur"),
        t("offerModal.semiPro"),
        t("offerModal.professional"),
        t("offerModal.elite")
    ];

    const COACH_POSITIONS = [
        t("offerModal.coachMain"),
        t("offerModal.coachAssistant"),
        t("offerModal.goalkeeperCoach"),
        t("offerModal.tacticalCoach"),
        t("offerModal.performanceAnalyst"),
        t("offerModal.academyDirector")
    ];

    const AGENT_STATUSES = [
        t("offerModal.fifaAgent"),
        t("offerModal.faAgent"),
        t("offerModal.fffAgent"),
        t("offerModal.frmfAgent"),
        t("offerModal.sportsIntermediary"),
        t("offerModal.sportsManager"),
        t("offerModal.sportsConsultant")
    ];

    const resetModal = () => {

        setStep(1);
        setFeedback("");
        setFeedbackType("");
        setLoading(false);
        setOfferData({
            role: "",
            title: "",
            description: "",
            country: "",
            city: "",
            filters: {
                sport: "Football",
                position: "",
                level: "",
                country: "",
                strong_foot: "",
                height_min: "",
                age_min: "",
                age_max: "",
                licence: "",
                status: ""
            }
        });
        onClose();
    };

    const publishOffer = async () => {

        try {
            setLoading(true);
            const response = await post(
                "offers",
                {
                    role:
                        offerData.role,

                    title:
                        offerData.title,

                    description:
                        offerData.description,

                    country:
                        offerData.country,

                    city:
                        offerData.city,

                    filters:
                        offerData.filters

                }

            );


            if (
                response?.message === "OFFER_CREATED"
            ) {

                setFeedback(
                    t("offerModal.success")
                );

                setFeedbackType(
                    "success"
                );

                setTimeout(() => {

                    resetModal();

                }, 1500);

            }
            else {

                setFeedback(
                    t("offerModal.publishError")
                );

                setFeedbackType(
                    "error");

            }

        }
        catch (err) {

            setFeedback(
                t("offerModal.genericError")
            );

            setFeedbackType(
                "error"
            );

        }

        finally {

            setLoading(false);

        }

    };

    return (

        <div
            className="offer-modal-overlay"
            onClick={resetModal}
        >

            <div
                className="offer-modal"
                onClick={(e) =>
                    e.stopPropagation()
                }
            >

                <div className="offer-header">

                    <div className="offer-badge">
                        <FaBriefcase />
                    </div>

                    <div>

                        <h2>
                            {t("offerModal.title")}
                        </h2>

                        <p>
                            {t("offerModal.subtitle")}
                        </p>

                    </div>

                    <button
                        className="offer-close"
                        type="button"
                        onClick={resetModal}
                        aria-label={t("offerModal.cancel")}
                    >
                        <FaTimes />
                    </button>

                </div>

                <div className="offer-step-indicator" aria-label={`Étape ${step} sur 2`}>
                    <span className={step === 1 ? "active" : "done"}>01</span>
                    <i />
                    <span className={step === 2 ? "active" : ""}>02</span>
                </div>

                {/* STEP 1 */}

                {step === 1 && (

                    <>

                        <div className="offer-role-grid">

                            {OFFER_ROLES.map((item) => (

                                <div
                                    key={item.key}
                                    className={`offer-role-card ${offerData.role === item.key
                                        ? "active"
                                        : ""
                                        }`}
                                    onClick={() =>
                                        setOfferData({
                                            ...offerData,
                                            role: item.key
                                        })
                                    }
                                >

                                    <div className="offer-role-icon">
                                        {item.icon}
                                    </div>

                                    <span>
                                        {item.label}
                                    </span>

                                </div>

                            ))}

                        </div>



                        <div className="offer-actions">

                            <button
                                className="offer-cancel"
                                onClick={resetModal}
                            >
                                {t("offerModal.cancel")}
                            </button>

                            <button
                                className="offer-next"
                                disabled={!offerData.role}
                                onClick={() =>
                                    setStep(2)
                                }
                            >
                                {t("offerModal.continue")}
                            </button>

                        </div>

                    </>

                )}

                {/* STEP 2 */}

                {step === 2 && (

                    <div className="offer-step-two">

                        <input
                            type="text"
                            placeholder={t("offerModal.offerTitle")}
                            value={offerData.title}
                            onChange={(e) =>
                                setOfferData({
                                    ...offerData,
                                    title: e.target.value
                                })
                            }
                        />

                        <textarea
                            placeholder={t("offerModal.description")}
                            value={offerData.description}
                            onChange={(e) =>
                                setOfferData({
                                    ...offerData,
                                    description:
                                        e.target.value
                                })
                            }
                        />

                        {/* ATHLETE */}

                        {offerData.role ===
                            "athlete" && (

                                <>

                                    <select
                                        onChange={(e) =>
                                            setOfferData({

                                                ...offerData,

                                                filters: {

                                                    ...offerData.filters,

                                                    position:
                                                        e.target.value

                                                }

                                            })
                                        }
                                    >

                                        <option value="">
                                            {t("offerModal.positionWanted")}
                                        </option>

                                        <option>
                                            {t("offerModal.goalkeeper")}
                                        </option>

                                        <option>
                                            {t("offerModal.defender")}
                                        </option>

                                        <option>
                                            {t("offerModal.midfielder")}
                                        </option>

                                        <option>
                                            {t("offerModal.forward")}
                                        </option>



                                    </select>

                                    <select
                                        onChange={(e) =>
                                            setOfferData({

                                                ...offerData,

                                                filters: {

                                                    ...offerData.filters,

                                                    level:
                                                        e.target.value

                                                }

                                            })
                                        }
                                    >

                                        <option value="">
                                            {t("offerModal.level")}
                                        </option>

                                        {LEVELS.map((lvl) => (
                                            <option key={lvl}>
                                                {lvl}
                                            </option>
                                        ))}

                                    </select>

                                    <select
                                        onChange={(e) =>
                                            setOfferData({

                                                ...offerData,

                                                filters: {

                                                    ...offerData.filters,

                                                    strong_foot:
                                                        e.target.value

                                                }

                                            })
                                        }
                                    >

                                        <option value="">
                                            {t("offerModal.strongFoot")}
                                        </option>

                                        <option value="Right">
                                            {t("offerModal.rightFoot")}
                                        </option>

                                        <option value="Left">
                                            {t("offerModal.leftFoot")}
                                        </option>

                                        <option value="Both">
                                            {t("offerModal.bothFeet")}
                                        </option>

                                    </select>

                                    <input
                                        type="number"
                                        placeholder={t("offerModal.minHeight")}
                                        onChange={(e) =>
                                            setOfferData({

                                                ...offerData,

                                                filters: {

                                                    ...offerData.filters,

                                                    height_min:
                                                        e.target.value

                                                }

                                            })
                                        }
                                    />

                                    <div className="offer-row">

                                        <input
                                            type="number"
                                            placeholder={t("offerModal.minAge")}
                                            onChange={(e) =>
                                                setOfferData({

                                                    ...offerData,

                                                    filters: {

                                                        ...offerData.filters,

                                                        age_min:
                                                            e.target.value

                                                    }

                                                })
                                            }
                                        />

                                        <input
                                            type="number"
                                            placeholder={t("offerModal.maxAge")}
                                            onChange={(e) =>
                                                setOfferData({

                                                    ...offerData,

                                                    filters: {

                                                        ...offerData.filters,

                                                        age_max:
                                                            e.target.value

                                                    }

                                                })
                                            }
                                        />

                                    </div>

                                </>

                            )}

                        {/* COACH */}

                        {offerData.role ===
                            "coach" && (

                                <>

                                    <select
                                        onChange={(e) =>
                                            setOfferData({

                                                ...offerData,

                                                filters: {

                                                    ...offerData.filters,

                                                    position:
                                                        e.target.value

                                                }

                                            })
                                        }
                                    >

                                        <option value="">
                                            {t("offerModal.position")}
                                        </option>

                                        {COACH_POSITIONS.map((p) => (
                                            <option key={p}>
                                                {p}
                                            </option>
                                        ))}

                                    </select>

                                    <select
                                        onChange={(e) =>
                                            setOfferData({

                                                ...offerData,

                                                filters: {

                                                    ...offerData.filters,

                                                    level:
                                                        e.target.value

                                                }

                                            })
                                        }
                                    >

                                        <option value="">
                                            {t("offerModal.level")}
                                        </option>

                                        {LEVELS.map((lvl) => (
                                            <option key={lvl}>
                                                {lvl}
                                            </option>
                                        ))}

                                    </select>

                                </>

                            )}

                        {/* STAFF */}

                        {[
                            "physical_trainer",
                            "scout",
                            "video_analyst",
                            "physio",
                            "nutritionist",
                            "mental_coach"
                        ].includes(
                            offerData.role
                        ) && (

                                <select
                                    onChange={(e) =>
                                        setOfferData({

                                            ...offerData,

                                            filters: {

                                                ...offerData.filters,

                                                level:
                                                    e.target.value

                                            }

                                        })
                                    }
                                >

                                    <option value="">
                                        {t("offerModal.level")}
                                    </option>

                                    {LEVELS.map((lvl) => (
                                        <option key={lvl}>
                                            {lvl}
                                        </option>
                                    ))}

                                </select>

                            )}

                        {/* AGENT */}

                        {offerData.role ===
                            "agent" && (

                                <select
                                    onChange={(e) =>
                                        setOfferData({
                                            ...offerData,
                                            filters: {
                                                ...offerData.filters,
                                                status:
                                                    e.target.value
                                            }
                                        })
                                    }
                                >

                                    <option value="">
                                        {t("offerModal.agentType")}
                                    </option>

                                    {AGENT_STATUSES.map((s) => (
                                        <option key={s}>
                                            {s}
                                        </option>
                                    ))}

                                </select>

                            )}

                        {
                            feedback && (

                                <div
                                    className={

                                        `offer-feedback ${feedbackType}`

                                    }
                                >

                                    <div className="offer-feedback-icon">

                                        {

                                            feedbackType === "success"

                                                ?

                                                "✓"

                                                :

                                                "!"

                                        }

                                    </div>

                                    <div>

                                        {feedback}

                                    </div>

                                </div>

                            )
                        }

                        <div className="offer-actions">

                            <button
                                className="offer-cancel"
                                onClick={() =>
                                    setStep(1)
                                }
                            >
                                {t("offerModal.back")}
                            </button>

                            <button
                                className="offer-publish"
                                onClick={publishOffer}
                                disabled={loading}
                            >

                                {

                                    loading
                                        ? t("offerModal.publishing")
                                        : t("offerModal.publish")

                                }

                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );

}
